import { createStore, applyMiddleware } from 'redux';
import rootReducer from './reducers';
import thunk from 'redux-thunk';


export default function configureStore(initialState) {

     // To maintain the state during refresh 
    if(sessionStorage.getItem('storeDesign')){

      let storeSettingData = {};
      let orderDataDetails = {};
      // storeSettingData.storeDesign = JSON.parse(sessionStorage.getItem('storeDesign'))
      // orderDataDetails.orderData = JSON.parse(sessionStorage.getItem('orderData'))
      // orderDataDetails.orderListing = JSON.parse(sessionStorage.getItem('orderListing'))
      // orderDataDetails.email = ''
      orderDataDetails.searchString =""
      orderDataDetails.orderIdentifier =""
      if(orderDataDetails.orderData)
        orderDataDetails.orderData.errorMessage= ""

      if(orderDataDetails.orderListing)
      orderDataDetails.orderListing.errorMessage= ""

      initialState = {
        storeSettingData:storeSettingData,
        orderDataDetails:orderDataDetails
      } 
   }
     
    return createStore(
        rootReducer,
        applyMiddleware(thunk)
    );
}


// WEBPACK FOOTER //
// ./src/redux/configureStore.prod.js